;(function () {

"use strict";

var PageView = Backbone.View.extend({
  initialize: function () {
  },

  events: {
    'click #nominate-button': function (e) {
      e.preventDefault();
      e.stopPropagation();

      var pollId = '5ee7c1912f34f14565de67b7';
      window.Zigpoll.pollId = pollId;
      window.Zigpoll.onload = function () {
        window.Zigpoll.open();
      }
      window.Zigpoll.refresh();
    }
  }
});

module.exports = PageView;

}());